import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SLRow, SLItem } from '../Optimize/shared/List';

const Wrapper = styled.div``;
const fill = Array(20).fill({});
const ToolkitTabQuestions = ({ loading, appData, functions }) => {
  const items = useMemo(
    () =>
      loading
        ? fill
        : (appData?.qts?.questions || [])?.map(i => ({ ...i, title: i.term })),
    [appData?.qts?.questions, loading],
  );

  const render = useMemo(
    () => (
      <>
        <SLRow header sticky style={{ top: 0, zIndex: 999999 }}>
          <SLItem header grow>
            Related Questions
          </SLItem>
        </SLRow>
        {items.map((item, i) => (
          <SLRow
            key={`item-${item?.title || i}`}
            data-mms--sidebar-item={`item-${i + 1}`}
          >
            <SLItem
              grow
              pr={0}
              pl={0}
              loading={loading}
              draggable
              onDragStart={functions.onItemDragStart.bind(this, item)}
            >
              {item.title}
            </SLItem>
          </SLRow>
        ))}
      </>
    ),
    [items, loading, functions],
  );

  return (
    <Wrapper data-mms--brief-subheadings-sidebar-content="questions">
      {render}
    </Wrapper>
  );
};

ToolkitTabQuestions.propTypes = {
  appData: PropTypes.object,
  moveForwardTo: PropTypes.func,
  moveBackTo: PropTypes.func,
};

export default ToolkitTabQuestions;
